/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { List, Record } from 'immutable'
import MonthlyClosingEvent from '../../event/MonthlyClosingEvent'

const EditViewState = Record({
  deleted_ids: List()
})

class EditViewStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new EditViewState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case MonthlyClosingEvent.onDeleteDetail:
        if (!payload.id) return state
        const _state = state
        return state.set('deleted_ids', _state.deleted_ids.push(payload.id))

      default:
        return state
    }
  }
}

export default new EditViewStore()
